'use client';

import Modal from '@/components/Modal';
import { Description, Title } from '@radix-ui/react-dialog';
import Image from 'next/image';
import { useState } from 'react';
import { PiPlayFill } from 'react-icons/pi';

import vtVideo from '../../../../public/vt-video.jpg';

export function HomeVideoEmbed() {
  const [modalIsOpen, setModalIsOpen] = useState(false);

  return (
    <section className="pt-24 pb-0 desktop:py-32 w-full z-10">
      <div className="w-screen aspect-video bg-blue">
        <div className="absolute w-screen left-0 aspect-video group ">
          <Modal.Root open={modalIsOpen} onOpenChange={setModalIsOpen}>
            <Modal.Trigger>
              <div className="cursor-pointer">
                <Image
                  src={vtVideo}
                  alt="Video"
                  fill
                  quality={90}
                  style={{ objectFit: 'cover' }}
                  className="aspect-video w-full brightness-90 group-hover:brightness-95 transition-all"
                />
                <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 size-20 group-hover:bg-white/70 group-hover:scale-125 transition-all rounded-full border-white/50 border-4 group-hover:border-transparent duration-500" />
                <PiPlayFill className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 size-6 text-white/90 group-hover:text-white group-hover:scale-110 transition-all duration-500" />
              </div>
            </Modal.Trigger>
            <Modal.Content
              onOpenChange={setModalIsOpen}
              contentCustomClass="bg-white/20 border-white/30 p-2 w-[99vw] desktop:w-[80vw] desktop:max-w-none aspect-video max-w-none z-[999] -translate-x-2/4 -translate-y-2/4 animate-open-modal left-2/4 top-2/4">
              <Title className="hidden" />
              <Description className="hidden" />
              <iframe
                width="100%"
                height="100%"
                src="https://www.youtube.com/embed/YNlLvW3F0SI"
                title="Villatravellers - Start Dreaming of a Villa Holiday in Sicily"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerPolicy="strict-origin-when-cross-origin"
                allowFullScreen
              />
            </Modal.Content>
          </Modal.Root>
        </div>
      </div>
    </section>
  );
}
